import { Token } from './token';

export default interface UserTokenSettable {
  setToken(token: Token): void;
}

export function isUserTokenSettable(object: unknown): object is UserTokenSettable {
  return (<UserTokenSettable>object).setToken !== undefined;
}
